(function ($) {
  var TAP_MAX_MOVE = 15;
  var touchState = null;

  var PDP_FANCYBOX_OPTS = {
    baseClass: 'pdp-fancybox',
    closeExisting: true,
    buttons: ['close'],
    arrows: true,
    infobar: false,
    toolbar: true,
    smallBtn: false,
    idleTime: false,
    thumbs: {
      autoStart: true,
      hideOnClose: true
    },
    loop: true,
    protect: false,
    animationEffect: 'fade',
    transitionEffect: 'slide',
    clickContent: false,
    clickSlide: false,
    clickOutside: 'close',
    wheel: false,
    image: {
      preload: true
    },
    margin: [72, 72, 100, 72],
    touch: false,
    afterShow: onPdpGalleryShow,
    beforeShow: function () {
      resetLightboxPinchZoom(false);
      resetPdpHoverZoom();
    },
    afterClose: cleanupAfterClose
  };

  var LB_ZOOM_SCALE = 2.5;
  var LB_MAX_SCALE = 4;
  var lbZoom = {
    scale: 1,
    x: 0,
    y: 0,
    $img: null,
    dragging: false,
    moved: false,
    lastX: 0,
    lastY: 0,
    isToggledZoom: false
  };

  function getLightboxImage(instance) {
    instance = getActiveInstance(instance);
    if (!instance || !instance.current || !instance.current.$slide) {
      return $();
    }

    return instance.current.$slide.find('.fancybox-image');
  }

  function applyLightboxPinchZoom($img, animate) {
    if (!$img || !$img.length) {
      return;
    }

    $img.css({
      transformOrigin: '0 0',
      transition: animate ? 'transform 0.22s ease' : 'none',
      transform: 'translate(' + lbZoom.x + 'px, ' + lbZoom.y + 'px) scale(' + lbZoom.scale + ')'
    });

    var instance = $.fancybox.getInstance();
    if (instance && instance.$refs && instance.$refs.container) {
      instance.$refs.container.toggleClass('is-pdp-zoomed', lbZoom.scale > 1.02);
      instance.$refs.container.toggleClass('is-pdp-zoomable', lbZoom.scale <= 1.02);
    }
  }

  function resetLightboxPinchZoom(animate) {
    lbZoom.scale = 1;
    lbZoom.x = 0;
    lbZoom.y = 0;
    lbZoom.dragging = false;
    lbZoom.moved = false;

    if (lbZoom.$img && lbZoom.$img.length) {
      applyLightboxPinchZoom(lbZoom.$img, animate);
    }
  }

  function zoomLightboxToPoint($img, clientX, clientY, targetScale) {
    var rect = $img[0].getBoundingClientRect();
    var imgX = (clientX - rect.left - lbZoom.x) / Math.max(lbZoom.scale, 0.001);
    var imgY = (clientY - rect.top - lbZoom.y) / Math.max(lbZoom.scale, 0.001);

    lbZoom.scale = Math.min(LB_MAX_SCALE, Math.max(1, targetScale));
    lbZoom.x = clientX - rect.left - imgX * lbZoom.scale;
    lbZoom.y = clientY - rect.top - imgY * lbZoom.scale;
    lbZoom.$img = $img;
    applyLightboxPinchZoom($img, true);
  }

  function toggleLightboxPinchZoom(e, instance) {
    var $img = getLightboxImage(instance);
    if (!$img.length) {
      return;
    }

    if (lbZoom.scale > 1.02) {
      resetLightboxPinchZoom(true);
      return;
    }

    zoomLightboxToPoint($img, e.clientX, e.clientY, LB_ZOOM_SCALE);
  }

  function applyDesktopLightboxPan(e, $content) {
    var $img = lbZoom.$img;
    if (!$img || !$img.length) return;

    var rect = $content[0].getBoundingClientRect();
    var x = e.clientX - rect.left;
    var y = e.clientY - rect.top;
    var px = (x / rect.width) * 100;
    var py = (y / rect.height) * 100;

    $img.css({
      transformOrigin: px + '% ' + py + '%',
      transform: 'scale(' + lbZoom.scale + ')'
    });
  }

  function bindLightboxPinchZoom(instance) {
    if (!instance || !instance.$refs || !instance.$refs.stage) {
      return;
    }

    var $stage = instance.$refs.stage;
    $stage.off('.pdpLbZoom');
    resetLightboxPinchZoom(false);
    lbZoom.$img = getLightboxImage(instance);

    if (!isMobileGallery()) {
      lbZoom.isToggledZoom = true;
      lbZoom.scale = LB_ZOOM_SCALE;
      
      if (lbZoom.$img.length) {
        lbZoom.$img.css({
          transformOrigin: '50% 50%',
          transition: 'transform 0.22s ease',
          transform: 'scale(' + lbZoom.scale + ')'
        });
      }

      $stage.on('mousemove.pdpLbZoom', '.fancybox-slide--current .fancybox-content', function (e) {
        if (!lbZoom.isToggledZoom) return;
        lbZoom.$img = getLightboxImage(instance);
        applyDesktopLightboxPan(e, $(this));
      });

      $stage.on('click.pdpLbZoom', '.fancybox-slide--current .fancybox-content', function (e) {
        if ($(e.target).closest('.fancybox-button, .fancybox-thumbs, .fancybox-toolbar').length) {
          return;
        }

        e.preventDefault();
        e.stopPropagation();
        
        lbZoom.isToggledZoom = !lbZoom.isToggledZoom;
        lbZoom.$img = getLightboxImage(instance);
        
        if (lbZoom.isToggledZoom) {
          lbZoom.scale = LB_ZOOM_SCALE;
          lbZoom.$img.css('transition', 'transform 0.22s ease');
          applyDesktopLightboxPan(e, $(this));
        } else {
          lbZoom.scale = 1;
          lbZoom.$img.css({
            transition: 'transform 0.22s ease',
            transform: 'translate(0px, 0px) scale(1)'
          });
        }
        
        var instanceActive = $.fancybox.getInstance();
        if (instanceActive && instanceActive.$refs) {
          instanceActive.$refs.container.toggleClass('is-pdp-zoomed', lbZoom.isToggledZoom);
          instanceActive.$refs.container.toggleClass('is-pdp-zoomable', !lbZoom.isToggledZoom);
        }
      });
      
      return;
    }

    $stage.on('click.pdpLbZoom', '.fancybox-slide--current .fancybox-content', function (e) {
      if ($(e.target).closest('.fancybox-button, .fancybox-thumbs, .fancybox-toolbar').length) {
        return;
      }

      if (lbZoom.moved) {
        lbZoom.moved = false;
        return;
      }

      e.preventDefault();
      e.stopPropagation();
      toggleLightboxPinchZoom(e, instance);
    });

    $stage.on('mousedown.pdpLbZoom', '.fancybox-slide--current .fancybox-content', function (e) {
      if (e.which !== 1 || lbZoom.scale <= 1.02) {
        return;
      }

      lbZoom.dragging = true;
      lbZoom.moved = false;
      lbZoom.lastX = e.clientX;
      lbZoom.lastY = e.clientY;
      e.preventDefault();
    });

    $stage.on('mousemove.pdpLbZoom', function (e) {
      if (!lbZoom.dragging || lbZoom.scale <= 1.02) {
        return;
      }

      var dx = e.clientX - lbZoom.lastX;
      var dy = e.clientY - lbZoom.lastY;

      if (Math.abs(dx) > 3 || Math.abs(dy) > 3) {
        lbZoom.moved = true;
      }

      lbZoom.x += dx;
      lbZoom.y += dy;
      lbZoom.lastX = e.clientX;
      lbZoom.lastY = e.clientY;
      applyLightboxPinchZoom(lbZoom.$img || getLightboxImage(instance), false);
    });

    $(document)
      .off('mouseup.pdpLbZoom')
      .on('mouseup.pdpLbZoom', function () {
        lbZoom.dragging = false;
      });

    $stage.on('wheel.pdpLbZoom', '.fancybox-slide--current .fancybox-content', function (e) {
      var oe = e.originalEvent;
      if (!oe) {
        return;
      }

      e.preventDefault();
      var $img = getLightboxImage(instance);
      if (!$img.length) {
        return;
      }

      var next = lbZoom.scale * (oe.deltaY > 0 ? 0.9 : 1.1);
      if (next <= 1.02) {
        resetLightboxPinchZoom(true);
        return;
      }

      zoomLightboxToPoint($img, oe.clientX, oe.clientY, next);
    });
  }

  function resetPdpHoverZoom() {
    if (window.resetAllPdpZoom) {
      window.resetAllPdpZoom();
    }

    window.__pdpZoomSuppressUntil = Date.now() + 600;
  }

  function cleanupAfterClose() {
    resetLightboxPinchZoom(false);
    $(document).off('mouseup.pdpLbZoom');
    resetPdpHoverZoom();
  }

  function isMobileGallery() {
    return window.innerWidth < 868;
  }

  function isGalleryLink(el) {
    if (!el || !el.matches || !el.matches('[data-fancybox="product-gallery"]')) {
      return false;
    }

    return !!(el.closest('.slider-for') || el.closest('.product-single__photo.pdp-zoom'));
  }

  function isGalleryTouchTarget(target) {
    if (!target || !target.closest) return false;
    return !!(
      target.closest('.product-single__photo.pdp-zoom') ||
      target.closest('.slider-for .slick-slide.slick-active')
    );
  }

  function getActiveGalleryLink() {
    var slide = document.querySelector('.slider-for .slick-slide.slick-active:not(.slick-cloned)');
    if (!slide) {
      slide = document.querySelector('.slider-for .slick-slide:not(.slick-cloned)');
    }
    if (!slide) return null;

    var link = slide.querySelector('[data-fancybox="product-gallery"]');
    return isGalleryLink(link) ? link : null;
  }

  function getGalleryLinkFromEvent(target) {
    if (!target || !target.closest) {
      return null;
    }

    var link = target.closest('[data-fancybox="product-gallery"]');
    if (isGalleryLink(link)) {
      return link;
    }

    var photo = target.closest('.product-single__photo.pdp-zoom');
    if (photo) {
      link = photo.querySelector('[data-fancybox="product-gallery"]');
      if (isGalleryLink(link)) {
        return link;
      }
    }

    return null;
  }

  function getGalleryLinkForInteraction(target, allowActiveFallback) {
    var link = getGalleryLinkFromEvent(target);
    if (link) {
      return link;
    }

    if (allowActiveFallback && isGalleryTouchTarget(target)) {
      return getActiveGalleryLink();
    }

    return null;
  }

  function getGalleryItems() {
    var seen = {};
    var $items = $('.slider-for .slick-slide:not(.slick-cloned) [data-fancybox="product-gallery"]').filter(function () {
      var href = this.getAttribute('href') || this.href;
      if (!href || seen[href]) {
        return false;
      }
      seen[href] = true;
      return true;
    });

    if (!$items.length) {
      $items = $('[data-fancybox="product-gallery"]');
    }

    return $items;
  }

  function resolveGalleryTrigger(el) {
    if (!el) {
      return null;
    }

    var href = el.getAttribute('href') || el.href;
    var $items = getGalleryItems();
    var match = null;

    $items.each(function () {
      if ((this.getAttribute('href') || this.href) === href) {
        match = this;
        return false;
      }
    });

    return match || $items.get(0) || el;
  }

  function isProductGalleryItems(items) {
    var el = $(items).get(0);
    return !!(el && el.getAttribute && el.getAttribute('data-fancybox') === 'product-gallery');
  }

  function wrapFancyboxOpen() {
    if (!$.fancybox || $.fancybox.__pdpOpenWrapped) {
      return;
    }

    var originalOpen = $.fancybox.open;

    $.fancybox.open = function (items, opts, index) {
      if (isProductGalleryItems(items)) {
        if (isMobileGallery()) {
          return null;
        }

        if (!opts || opts.baseClass !== 'pdp-fancybox') {
          var trigger = $(items).get(index) || $(items).get(0);
          var $items = getGalleryItems();
          var resolved = resolveGalleryTrigger(trigger);
          var cleanIndex = $items.index(resolved);

          if (cleanIndex < 0) {
            cleanIndex = 0;
          }

          return originalOpen.call(this, $items, PDP_FANCYBOX_OPTS, cleanIndex);
        }
      }

      return originalOpen.apply(this, arguments);
    };

    $.fancybox.__pdpOpenWrapped = true;
  }

  function openPdpGallery(trigger) {
    if (!$.fn.fancybox || !trigger || isMobileGallery()) {
      return;
    }

    resetPdpHoverZoom();

    if ($.fancybox.getInstance()) {
      return;
    }

    var $items = getGalleryItems();
    var resolved = resolveGalleryTrigger(trigger);
    var index = $items.index(resolved);

    if (index < 0) {
      index = 0;
    }

    $.fancybox.open($items, PDP_FANCYBOX_OPTS, index);
  }

  function getActiveInstance(maybeInstance) {
    if (maybeInstance && maybeInstance.$refs) {
      return maybeInstance;
    }

    return $.fancybox.getInstance();
  }

  function updateZoomState(instance) {
    if (!instance || !instance.$refs) {
      return;
    }

    var zoomed = lbZoom.scale > 1.02;
    instance.$refs.container.toggleClass('is-pdp-zoomed', zoomed);
    instance.$refs.container.toggleClass('is-pdp-zoomable', !zoomed);
  }

  function setupPdpToolbar(instance) {
    var $toolbar = instance.$refs.toolbar;

    if (!$toolbar || !$toolbar.length) {
      return;
    }

    instance.$refs.stage.find('.pdp-fancybox-zoom-controls').remove();
    instance.$refs.container.find('.pdp-fancybox-zoom-controls').remove();
    $toolbar.addClass('pdp-fancybox-toolbar--close-only');
  }

  function bindZoomStateSync(instance) {
    instance.$refs.container
      .off('click.pdpZoomState touchend.pdpZoomState transitionend.pdpZoomState')
      .on('click.pdpZoomState touchend.pdpZoomState transitionend.pdpZoomState', '.fancybox-content', function () {
        window.setTimeout(function () {
          updateZoomState(getActiveInstance(instance));
        }, 400);
      });
  }

  function onPdpGalleryShow(maybeInstance) {
    var instance = getActiveInstance(maybeInstance);

    if (!instance) {
      return;
    }

    setupPdpToolbar(instance);
    fixThumbsLayout(instance);
    bindLightboxPinchZoom(instance);
    bindZoomStateSync(instance);
    updateZoomState(instance);

    window.setTimeout(function () {
      if ($.fancybox.getInstance() === instance) {
        updateZoomState(instance);
      }
    }, 120);

    instance.$refs.container
      .off('transitionend.pdpZoomState')
      .on('transitionend.pdpZoomState', function () {
        window.setTimeout(function () {
          if ($.fancybox.getInstance() === instance) {
            updateZoomState(instance);
          }
        }, 40);
      });
  }

  function fixThumbsLayout(instance) {
    var $container = instance.$refs.container;
    var $list = $container.find('.fancybox-thumbs__list');

    if (!$list.length) {
      return;
    }

    $list.css({
      width: 'auto',
      transform: 'none',
      left: 'auto'
    });

    $list.find('a').css({
      position: 'relative',
      left: 'auto',
      top: 'auto',
      right: 'auto',
      float: 'none'
    });
  }

  function clearLegacyFancyboxBindings() {
    $('[data-fancybox="product-gallery"]').each(function () {
      $(this)
        .off('click.fb-start')
        .removeData('fancybox-opts')
        .removeData('pdp-fancybox-ready');
    });
  }

  function markGalleryOpened() {
    window.__pdpGalleryTouchOpened = Date.now();
  }

  function blockMobileGalleryOpen(e) {
    if (!isMobileGallery() || !e.target || !e.target.closest) {
      return false;
    }

    if (!e.target.closest('.slider-for [data-fancybox="product-gallery"], .product-single__photo.pdp-zoom a')) {
      return false;
    }

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    return true;
  }

  function onGalleryClickCapture(e) {
    var link = e.target && e.target.closest
      ? e.target.closest('[data-fancybox="product-gallery"]')
      : null;

    if (!link && e.target && e.target.closest) {
      var photo = e.target.closest('.product-single__photo.pdp-zoom');
      if (photo) {
        link = photo.querySelector('[data-fancybox="product-gallery"]');
      }
    }

    if (!isGalleryLink(link)) {
      return;
    }

    e.preventDefault();

    if (isMobileGallery()) {
      return;
    }

    e.stopPropagation();
    e.stopImmediatePropagation();
    openPdpGallery(link);
    return false;
  }

  function onGalleryTouchStartCapture(e) {
    if (isMobileGallery()) {
      touchState = null;
      return;
    }

    if (!isGalleryTouchTarget(e.target)) {
      touchState = null;
      return;
    }

    if (!e.touches || !e.touches.length) {
      touchState = null;
      return;
    }

    touchState = {
      x: e.touches[0].clientX,
      y: e.touches[0].clientY,
      moved: false,
      onGallery: true
    };
  }

  function onGalleryTouchMoveCapture(e) {
    if (!touchState || !touchState.onGallery || !e.touches || !e.touches.length) {
      return;
    }

    var dx = Math.abs(e.touches[0].clientX - touchState.x);
    var dy = Math.abs(e.touches[0].clientY - touchState.y);

    if (dx > TAP_MAX_MOVE || dy > TAP_MAX_MOVE) {
      touchState.moved = true;
    }
  }

  function onGalleryTouchEndCapture(e) {
    if (isMobileGallery()) {
      touchState = null;
      return;
    }

    if (!touchState || !touchState.onGallery) {
      touchState = null;
      return;
    }

    if (touchState.moved) {
      touchState = null;
      return;
    }

    if (!isGalleryTouchTarget(e.target)) {
      touchState = null;
      return;
    }

    var link = getGalleryLinkForInteraction(e.target, true);
    if (!link) {
      touchState = null;
      return;
    }

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    markGalleryOpened();
    openPdpGallery(link);
    touchState = null;
    return false;
  }

  function bindCaptureHandlers() {
    if (window.__pdpFancyboxCaptureBound) {
      return;
    }

    document.addEventListener('click', onGalleryClickCapture, true);
    document.addEventListener('touchstart', onGalleryTouchStartCapture, { capture: true, passive: true });
    document.addEventListener('touchmove', onGalleryTouchMoveCapture, { capture: true, passive: true });
    document.addEventListener('touchend', onGalleryTouchEndCapture, { capture: true, passive: false });
    window.__pdpFancyboxCaptureBound = true;
  }

  function initPdpFancybox() {
    if (!$.fn.fancybox) {
      return;
    }

    wrapFancyboxOpen();
    clearLegacyFancyboxBindings();
    bindCaptureHandlers();
  }

  window.initPdpFancybox = initPdpFancybox;
  window.openPdpGallery = openPdpGallery;

  $(document).ready(initPdpFancybox);
  $(document).on('shopify:section:load', initPdpFancybox);
})(jQuery);
